// Module
var code = "<select class=\"form-control\" ng-model=\"$ctrl.swValue\" ng-disabled=\"$ctrl.swReadOnly\" ng-change=\"$ctrl.swChange({value: $ctrl.swValue})\"> <option ng-value=\"language.code\" ng-repeat=\"language in $ctrl.languageList\"> {{ language.name }} </option> </select> ";
// Exports
export default code;